import { Youtube } from "./content/content";

/** Represents a pill, a short video that's displayed
 * for the user in a format similar to Instagram stories. */
export class Pill {
  /** ID of the pill. */
  public id: number;

  /** Title of the pill. */
  public title: string;

  /** Whether the pill is released to everybody or not. */
  public isPublic: boolean;

  public imageURL: string;

  /** Whether the pill will be shown to the user. */
  public isActive: boolean;

  /** Date of the last time the pill was updated. */
  public lastChange: string;

  /** Date in which the pill will become active (isActive = true). */
  public activationDate: string;

  /** Date in which the pill will become inactive (isActive = false). */
  public inactivationDate: string;

  public url: string;

  public youtube: Youtube;
  public isWatched: boolean;
  public idCourse: number;

  constructor(
    id = NaN,
    title = "",
    isPublic = false,
    imageURL = "",
    isActive = true,
    lastChange = "",
    activationDate = "",
    inactivationDate = "",
    url = "",
    youtube = new Youtube(),
    isWatched = false,
    idCourse = NaN
  ) {
    this.id = id;
    this.title = title;
    this.isPublic = isPublic;
    this.imageURL = imageURL;
    this.isActive = isActive;
    this.lastChange = lastChange;
    this.activationDate = activationDate;
    this.inactivationDate = inactivationDate;
    this.url = url;
    this.youtube = youtube;
    this.isWatched = isWatched;
    this.idCourse = idCourse;
  }
}

export class PillList {
  public pills: Pill[];
  public has_more: boolean;

  constructor(pills = [], has_more = false) {
    this.pills = pills;
    this.has_more = has_more;
  }
}
